/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RechercheExportGapSearch
 */
export interface RechercheExportGapSearch {
    /**
     * 
     * @type {number}
     * @memberof RechercheExportGapSearch
     */
    idexport?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheExportGapSearch
     */
    date?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheExportGapSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheExportGapSearch
     */
    description?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof RechercheExportGapSearch
     */
    valide?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RechercheExportGapSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RechercheExportGapSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheExportGapSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheExportGapSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RechercheExportGapSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RechercheExportGapSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RechercheExportGapSearch interface.
 */
export function instanceOfRechercheExportGapSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechercheExportGapSearchFromJSON(json: any): RechercheExportGapSearch {
    return RechercheExportGapSearchFromJSONTyped(json, false);
}

export function RechercheExportGapSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechercheExportGapSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idexport': !exists(json, 'idexport') ? undefined : json['idexport'],
        'date': !exists(json, 'date') ? undefined : TextSearchFromJSON(json['date']),
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'description': !exists(json, 'description') ? undefined : TextSearchFromJSON(json['description']),
        'valide': !exists(json, 'valide') ? undefined : BooleanSearchFromJSON(json['valide']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RechercheExportGapSearchToJSON(value?: RechercheExportGapSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idexport': value.idexport,
        'date': TextSearchToJSON(value.date),
        'centre': TextSearchToJSON(value.centre),
        'description': TextSearchToJSON(value.description),
        'valide': BooleanSearchToJSON(value.valide),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

